<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="title">关注公众号</div>
      <div class="sub-title">如遇到问题，可前往公众号寻求客服帮助。
客服工作时间为工作日10点~18点</div>
      <div class="qrcode"><img width="110" height="110" src="//cdn.hongbaoxd.com/images/c8ea1ad12b73723a23838d309b4e9701.png" alt="我是二维码"></div>
      <div class="desc">长按保存二维码</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 294px;
    padding: 30px 26px;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .sub-title {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();
    }

    .qrcode {
      width: 110px;
      height: 110px;
      background-color: #fff;
      margin: 0 auto 5px;

      img {
        pointer-events: auto;
      }
    }

    .desc {
      font-size: 13px;
      color: #B5B5B5;

      @include regular();
    }
  }
</style>
<script>
  import Dialog from 'components/Dialog'
  export default {
    components: {
      Dialog
    },
    methods: {
      show () {
        this.$refs.p.show()
      },
      hide () {
        this.$refs.p.hide()
      }
    }
  }
</script>
